import * as Sentry from '@sentry/react';
import { matchPath } from 'react-router-dom';

import identifyUser from 'utils/analytics/identifyUser';

export default function (history) {
  const sentryApp = process.env.REACT_APP_SENTRY_APP_ID;
  const environment = process.env.REACT_APP_MODE;

  if (sentryApp) {
    Sentry.init({
      dsn: sentryApp,
      environment,
      release: `${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_CURRENT_GIT_SHA}`,
      integrations: [
        Sentry.reactRouterV5BrowserTracingIntegration({
          history,
          matchPath,
        }),
      ],

      tracesSampleRate: 0.1, // Start low to control costs
    });
  }

  identifyUser();
}
